import {SvgIcon, useTheme} from '@mui/material';

export default function GenderIcon() {
	const theme = useTheme();
	return (
		<SvgIcon width="16" height="16" viewBox="0 0 16 16" fill="none">
			<path opacity="0.4"
			      d="M11.9998 9.16667C11.9998 12.02 9.6865 14.3333 6.83317 14.3333C3.97984 14.3333 1.6665 12.02 1.6665 9.16667C1.6665 6.31333 3.97984 4 6.83317 4C8.07984 4 9.21984 4.44 10.1132 5.18H10.1198C10.3798 5.39333 10.6132 5.62667 10.8198 5.88667C11.5598 6.78 11.9998 7.92 11.9998 9.16667Z"
			      fill={theme.palette.grey[600]}/>
			<path
				d="M14.8333 1.66663V5.99996C14.8333 6.27329 14.6067 6.49996 14.3333 6.49996C14.06 6.49996 13.8333 6.27329 13.8333 5.99996V2.87329L10.82 5.88663C10.6133 5.62663 10.38 5.39329 10.12 5.17996L13.1267 2.16663H10C9.72667 2.16663 9.5 1.93996 9.5 1.66663C9.5 1.39329 9.72667 1.16663 10 1.16663H14.3333C14.4 1.16663 14.46 1.17996 14.5267 1.20663C14.6467 1.25329 14.7467 1.35329 14.7933 1.47329C14.82 1.53996 14.8333 1.59996 14.8333 1.66663Z"
				fill={theme.palette.grey[600]}/>
		</SvgIcon>
	);
}
